
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import StoryCard from "./StoryCard";

type Story = {
  id: string;
  title: string;
  genre: string[];
  created_at: string;
  finished_at: string | null;
};

interface StoriesGridProps {
  stories: Story[];
  isLoading: boolean;
  isCompleted?: boolean;
  onStoryClick: (storyId: string, isCompleted: boolean) => void;
  refetchStories: () => void;
}

const StoriesGrid = ({ stories, isLoading, isCompleted = false, onStoryClick, refetchStories }: StoriesGridProps) => {
  const { t } = useLanguage();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="bg-white/5 backdrop-blur-sm border-white/10">
            <CardHeader>
              <Skeleton className="h-6 w-3/4" />
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-2/3" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {stories.map((story) => (
        <StoryCard
          key={story.id}
          story={story}
          isCompleted={isCompleted}
          onStoryClick={onStoryClick}
          onStoryDeleted={refetchStories}
        />
      ))}
    </div>
  );
};

export default StoriesGrid;
